import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const BoletoDisabledMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3874" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_3874)"
      />
      <Path
        d="M14.6246 10.0002C14.3263 10.0002 14.0401 10.1188 13.8291 10.3297C13.6182 10.5407 13.4996 10.8269 13.4996 11.1252V20.8752C13.4996 21.1736 13.6182 21.4598 13.8291 21.6707C14.0401 21.8817 14.3263 22.0002 14.6246 22.0002C14.923 22.0002 15.2092 21.8817 15.4201 21.6707C15.6311 21.4598 15.7496 21.1736 15.7496 20.8752V11.1252C15.7496 10.8269 15.6311 10.5407 15.4201 10.3297C15.2092 10.1188 14.923 10.0002 14.6246 10.0002Z"
        fill="#B8B8B8"
      />
      <Path
        d="M21.3746 10.0002H19.1246C18.5033 10.0002 17.9996 10.5039 17.9996 11.1252V20.8752C17.9996 21.4966 18.5033 22.0002 19.1246 22.0002H21.3746C21.996 22.0002 22.4996 21.4966 22.4996 20.8752V11.1252C22.4996 10.5039 21.996 10.0002 21.3746 10.0002Z"
        fill="#B8B8B8"
      />
      <Path
        d="M25.8746 10.0002C25.5763 10.0002 25.2901 10.1188 25.0791 10.3297C24.8682 10.5407 24.7496 10.8269 24.7496 11.1252V20.8752C24.7496 21.1736 24.8682 21.4598 25.0791 21.6707C25.2901 21.8817 25.5763 22.0002 25.8746 22.0002C26.173 22.0002 26.4591 21.8817 26.6701 21.6707C26.8811 21.4598 26.9996 21.1736 26.9996 20.8752V11.1252C26.9996 10.8269 26.8811 10.5407 26.6701 10.3297C26.4591 10.1188 26.173 10.0002 25.8746 10.0002Z"
        fill="#B8B8B8"
      />
      <Path
        d="M33.3746 10.0002H30.3746C29.7533 10.0002 29.2496 10.5039 29.2496 11.1252V20.8752C29.2496 21.4966 29.7533 22.0002 30.3746 22.0002H33.3746C33.996 22.0002 34.4996 21.4966 34.4996 20.8752V11.1252C34.4996 10.5039 33.996 10.0002 33.3746 10.0002Z"
        fill="#B8B8B8"
      />
      <Path
        d="M10.1248 10.0001C9.82645 10.0001 9.5403 10.1186 9.32932 10.3296C9.11834 10.5406 8.99982 10.8268 8.99982 11.1251V20.8751C8.99982 21.1735 9.11834 21.4596 9.32932 21.6706C9.5403 21.8816 9.82645 22.0001 10.1248 22.0001C10.4232 22.0001 10.7093 21.8816 10.9203 21.6706C11.1313 21.4596 11.2498 21.1735 11.2498 20.8751V11.1251C11.2498 10.9774 11.2207 10.8311 11.1642 10.6946C11.1076 10.5581 11.0248 10.4341 10.9203 10.3296C10.8158 10.2252 10.6918 10.1423 10.5553 10.0858C10.4188 10.0292 10.2726 10.0001 10.1248 10.0001Z"
        fill="#B8B8B8"
      />
      <Path
        d="M37.8745 10.0002C37.5761 10.0002 37.2899 10.1188 37.079 10.3297C36.868 10.5407 36.7495 10.8269 36.7495 11.1252V20.8752C36.7495 21.1736 36.868 21.4598 37.079 21.6707C37.2899 21.8817 37.5761 22.0002 37.8745 22.0002C38.1728 22.0002 38.459 21.8817 38.6699 21.6707C38.8809 21.4598 38.9995 21.1736 38.9995 20.8752V11.1252C38.9995 10.8269 38.8809 10.5407 38.6699 10.3297C38.459 10.1188 38.1728 10.0002 37.8745 10.0002Z"
        fill="#B8B8B8"
      />
    </Svg>
  )
}
